import React, { useState, useEffect } from 'react';
import { Container, Col, Row, Modal, Button, Card } from 'react-bootstrap';
import styles from './editSheduledInterviewsModal.module.scss';
import SendOfferConfigurations from './sendOfferConfigurations';
import Review from './review';


const SendOfferToCandidateModal = (props) => {
    let [step, setStep] = useState(1);
    const [values, setValues] = useState({ documents: [] });


    function nextPage(value) {
        setStep(value);
    }
    function previousPage(value) {
        setStep(value);
    }

    

    function updateValues(newValues) {
        setValues((prevState) => ({
            ...prevState,
            documents: [...newValues.documents] // Replace with new values
        }));
    }


    return (
        <div>

            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose} >
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Send Offer To Candidate</h2>
                    </div>
                    <Container>
                        <div className="mb-4">
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    VACANCY DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Pipeline Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.pipelineName}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                        <div>
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    CANDIDATE DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.candidateName}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Email</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.candidateEmail}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Phone</p>
                                        </Col>
                                        <Col>
                                            {(props.viewOfferValues.candidatePhoneCode && props.viewOfferValues.candidatePhoneNumber) ?
                                                <p className={styles.cardValues}>({props.viewOfferValues.candidatePhoneCode})&nbsp;{props.viewOfferValues.candidatePhoneNumber}</p>
                                                :
                                                <p className={styles.cardValues}>Not available</p>
                                            }
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className='mt-4'>
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    OFFER DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Job Title</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.jobTitle}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Allocation</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.allocation ? props.viewOfferValues.allocation : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Description</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}> {props.viewOfferValues.offerDescription ? props.viewOfferValues.offerDescription : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Package Reference</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.packageReference ? props.viewOfferValues.packageReference : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                    </Container>

                    <Col className={styles.stepPosition}>
                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>
                                {
                                    step === 1 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_613_29628)">
                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_613_29628">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                }

                            </div>
                            <div className={step === 2 ? styles.stepActive : ''}>
                                {
                                    step === 2 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 2) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#EAECF0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                        </div>
                    </Col>

                    <Container>
                        <div>
                            <p className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Documents (Offer Letters / Contracts, etc.)'
                                        : 'Review Documents'
                                }
                            </p>
                        </div>
                    </Container>

                    <Container>
                        {/* Rendering Content Goes Here */}
                        {step === 1 && props.showModal === true && <SendOfferConfigurations nextPage={nextPage} updateValues={updateValues} values={values} />}
                        {step === 2 && props.showModal === true && <Review previousPage={previousPage} handleClose={props.handleClose} values={values} offerSessionDetails={props.viewOfferValues} refreshData={props.refreshData} />}
                    </Container>

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default SendOfferToCandidateModal;
